import { BaseResource } from '../base-resource';

export class Asset extends BaseResource {
    constructor() {
        super();
        this.type = "Facility";
    }
}